import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import lookupService from 'nallian-shared-ui/lib/hoc/lookupService';
import apiRoutes from '../../../../app/api/routes';

const CommunityLookup = ({ id, communityLookupFetch }) => {
  const community = useMemo(() => (communityLookupFetch.value || []).find(c => c.id === id)?.name, [
    id,
    communityLookupFetch,
  ]);


  return <span>{community || '-'}</span>;
};

CommunityLookup.propTypes = {
  communityLookupFetch: PropTypes.object.isRequired,
  id: PropTypes.string,
};

CommunityLookup.defaultProps = { id: undefined };

export default lookupService({
  resource: 'communityLookup',
  url: apiRoutes.getCommunities(),
})(CommunityLookup);
